

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArticleSlider from "../components/Slider";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Home = () => {
  const [editions, setEditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1); // Current page
  const [hasMore, setHasMore] = useState(true); // Whether more editions exist
  const navigate = useNavigate();

  const fetchEditions = async (currentPage) => {
    try {
      const response = await axios.get(
        // `http://localhost:8000/api/editions/?page=${currentPage}`
        `https://api.bppreview.org/api/editions/?page=${currentPage}`
      );
      // Append new editions to the existing list
      // setEditions((prevEditions) => [...prevEditions, ...response.data.results]);
      setEditions((prevEditions) => {
        const newEditions = response.data.results;
        const uniqueEditions = [
          ...prevEditions,
          ...newEditions.filter(
            (edition) => !prevEditions.some((e) => e.id === edition.id)
          ),
        ];
        return uniqueEditions;
      });

      // Check if there are more pages
      setHasMore(response.data.next !== null);
    } catch (err) {
      setError("Failed to fetch editions. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Fetching page:", page);
    fetchEditions(page);
  }, [page]);

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  // if (loading && page === 1) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       {/* Circular Spinner Loader */}
  //       <div className="w-16 h-16 border-4 border-t-4 border-b-4 border-brown-500 border-solid rounded-full animate-spin"></div>
  //     </div>
  //   );
  // }

  // Replace loading spinner for the first page
  if (loading && page === 1) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-28">
        {Array(6)
          .fill(0)
          .map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-4">
              <Skeleton height={160} />
              <div className="p-4">
                <Skeleton height={20} width="70%" />
                <Skeleton height={15} width="50%" className="mt-2" />
                <Skeleton height={30} width="100%" className="mt-4" />
              </div>
            </div>
          ))}
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <div className="mt-16">
      <div>
        <ArticleSlider />
      </div>
      <div className="container mx-auto p-4 mt-8">
        {editions.length === 0 ? (
          <p className="text-center text-gray-500">No editions available.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {editions.map((edition) => (
              <div
                key={edition.id}
                className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow"
              >
                <div className="h-fit bg-gray-100 rounded-t-lg flex items-center justify-center">
                  {/* Display the cover image if it exists */}
                  {edition.coverimage ? (
                    // <img
                    //   src={edition.coverimage} // Assuming coverimage is a URL
                    //   alt={`${edition.name} cover`}
                    //   className="h-full w-full object-cover rounded-t-lg"
                    // />
                    <LazyLoadImage
                      src={edition.coverimage}
                      alt={`${edition.name} cover`}
                      effect="blur" // Adds a blur effect while loading
                      className="h-full w-full object-cover rounded-t-lg"
                    />
                  ) : (
                    <span className="text-gray-400">Image Placeholder</span>
                  )}
                </div>
                <div className="p-4">
                  <h2 className="text-lg font-bold text-gray-700">
                    {edition.name}
                  </h2>
                  <p className="text-sm text-gray-500">
                    <strong>Publication Date:</strong> {edition.release_date}
                  </p>
                  <div className="mt-4">
                    {/* <a
                      href={edition.pdf_file}
                      className="block text-blue-500 underline hover:text-blue-700"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download All Articles
                    </a> */}
                    <button
                      onClick={() =>
                        navigate(`/editions/${edition.id}/articles`, {
                          state: { description: edition.description }, // Pass the description as state
                        })
                      }
                      className="mt-2 bg-[#b3976b] text-white px-4 py-2 rounded hover:bg-[#b3976b] transition"
                    >
                      View All Articles
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Load More Button */}
        {hasMore && !loading && (
          <div className="flex justify-center mt-6">
            <button
              onClick={loadMore}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
            >
              Load More
            </button>
          </div>
        )}

        {/* Show loading spinner when fetching more */}
        {loading && page > 1 && (
          <div className="flex justify-center mt-6">
            <div className="w-8 h-8 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
